/** New chat contact picker (06 S10). Opens/creates a direct conversation. */
import { useNavigate } from 'react-router-dom';
import { Users } from 'lucide-react';
import { useChatStore } from '../../stores/chatStore';
import { useUiStore } from '../../stores/uiStore';
import { USERS } from '../../data/mockData';
import { OverlayPanel } from '../primitives/OverlayPanel';
import { ContactPickerRow } from './ContactPickerRow';
import styles from './NewChat.module.css';

export function NewChat() {
  const navigate = useNavigate();
  const conversations = useChatStore((s) => s.conversations);
  const closeLeftOverlay = useUiStore((s) => s.closeLeftOverlay);
  const setLeftOverlay = useUiStore((s) => s.setLeftOverlay);

  const openDirect = (userId: string) => {
    const existing = conversations.find((c) => c.type === 'direct' && c.peerId === userId);
    closeLeftOverlay();
    if (existing) navigate(`/chats/${existing.id}`);
  };

  return (
    <OverlayPanel title="New chat" onBack={closeLeftOverlay}>
      <button
        className={styles.newGroup}
        onClick={() => setLeftOverlay({ kind: 'new-group-members', selected: [] })}
      >
        <span className={styles.groupIcon}>
          <Users size={22} />
        </span>
        New group
      </button>
      <h2 className={styles.section}>Contacts on Sinyal</h2>
      <ul>
        {USERS.map((u) => (
          <li key={u.id}>
            <ContactPickerRow user={u} onClick={() => openDirect(u.id)} />
          </li>
        ))}
      </ul>
    </OverlayPanel>
  );
}
